import { tabs, type Tab } from './navTabs'
import './TabPlaceholder.css'

interface TabPlaceholderProps {
  tab: Tab
}

/** Lightweight stand-in for a neighbouring tab's page, shown mid-drag
 * instead of mounting its full (heavily-propped) component. */
function TabPlaceholder({ tab }: TabPlaceholderProps) {
  const meta = tabs.find((t) => t.id === tab)
  if (!meta) return null
  const Icon = meta.icon
  return (
    <div className="tab-placeholder">
      <Icon className="tab-placeholder__icon" aria-hidden="true" />
      <span className="tab-placeholder__label">{meta.label}</span>
    </div>
  )
}

export default TabPlaceholder
